import { Box, Typography, Button } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/routes/paths';

// Shown by RouteGuard when an authenticated admin lacks the route's permission.
export default function ForbiddenPage() {
  const navigate = useNavigate();
  return (
    <Box sx={{ textAlign: 'center', py: 10 }}>
      <LockIcon sx={{ fontSize: 56, color: 'warning.main' }} />
      <Typography variant="h5" sx={{ mt: 1 }}>
        Access denied
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Your role doesn’t have permission to view this page.
      </Typography>
      <Button variant="contained" onClick={() => navigate(ROUTES.DASHBOARD)}>
        Back to Dashboard
      </Button>
    </Box>
  );
}
